module.exports = __webpack_public_path__ + "c5eb7f233b097ecfc5f78b3959907dcc.svg";